<template>
  <div>
    <button
      v-for="code in locales"
      :key="code"
      class="ma-2"
      :class="locale === code ? 'font-weight-bold d-none d-sm-inline-block' : 'd-inline-block'"
      @click="setLocale(code)"
    >
      {{ code }}
    </button>
  </div>
</template>

<script>
import { localeChanged } from 'vee-validate';
import { locales } from '@/locales';
import { saveLocale, isValidLocale } from '@/locales/helpers';

export default {
  name: 'LocaleChange',
  computed: {
    locale() {
      return this.$root.$i18n.locale;
    },
    locales() {
      return locales;
    },
  },
  created() {
    const { lang } = this.$route.query;
    this.$router.replace({ query: {} });

    if (!lang || !locales.includes(lang)) {
      return;
    }

    this.setLocale(lang);
  },
  methods: {
    setLocale(locale) {
      if (!isValidLocale(locale)) {
        return;
      }

      saveLocale(locale);
      this.$i18n.locale = locale;
      localeChanged();
    },
  },
};
</script>

<style scoped></style>
